// @ts-nocheck
import * as Types from "../../../../types/types-v2.generated";

import { gql } from "@apollo/client";
export type CheckpointStartingViewServerFragment = {
  __typename?: "Server";
  logAnalysis: {
    __typename?: "LogAnalysis";
    checkpointStarting: Array<{
      __typename?: "CheckpointStartingStat";
      bucketStart: string;
      reason?: string | null;
      count: number;
    }>;
  };
  postgresConfig: {
    __typename?: "PostgresConfig";
    settings: Array<{
      __typename?: "Setting";
      name: string;
      value?: string | null;
    }>;
  };
};

export type TempFileCreatedViewServerFragment = {
  __typename?: "Server";
  logAnalysis: {
    __typename?: "LogAnalysis";
    tempFileCreated: Array<{
      __typename?: "TempFileCreatedStat";
      bucketStart: string;
      count: number;
      avgSizeBytes?: number | null;
      query?: {
        __typename?: "Query";
        id: string;
        databaseId: string;
        displaySql: string;
      } | null;
    }>;
  };
  postgresConfig: {
    __typename?: "PostgresConfig";
    settings: Array<{
      __typename?: "Setting";
      name: string;
      value?: string | null;
    }>;
  };
};

export const CheckpointStartingViewServerFragmentDoc = gql`
  fragment CheckpointStartingViewServer on Server {
    logAnalysis {
      checkpointStarting(from: $from, to: $to) {
        bucketStart
        reason
        count
      }
    }
    postgresConfig {
      settings(
        names: [
          "checkpoint_completion_target"
          "checkpoint_timeout"
          "max_wal_size"
          "checkpoint_segments"
        ]
      ) {
        name
        value
      }
    }
  }
`;
export const TempFileCreatedViewServerFragmentDoc = gql`
  fragment TempFileCreatedViewServer on Server {
    logAnalysis {
      tempFileCreated(from: $from, to: $to, databaseId: $databaseId) {
        bucketStart
        count
        avgSizeBytes
        query {
          id
          databaseId
          displaySql
        }
      }
    }
    postgresConfig {
      settings(names: ["work_mem"]) {
        name
        value
      }
    }
  }
`;
